'use strict';

// http://262.ecma-international.org/5.1/#sec-9.11

module.exports = require('is-callable');



//////////////////
// WEBPACK FOOTER
// ./~/array.prototype.find/~/es-abstract/2019/IsCallable.js
// module id = 2713
// module chunks = 0